/*
 * @Author: 田鑫
 * @Date: 2021-08-08 13:31:11
 * @LastEditors: 田鑫
 * @LastEditTime: 2021-08-09 20:55:46
 * @Version: Cocos Creator V2.2.2
 * @Description:
 */
// --- 保障用户管理 --- //

export default [
  {
    name: "userManagement",
    path: "/supplySystem/:supplyId/ensureUserManagement/list",
    meta: { title: "用户管理" },
    component: require("business/supplySystem/ensureUserManagement/list.vue").default
  },
  {
    name: "ensureLevelList",
    path: "/supplySystem/:supplyId/ensureUserManagement/ensureLevel",
    meta: { title: "保障级别" },
    component: require("business/supplySystem/ensureUserManagement/ensureLevel.vue").default
  },
  {
    name: "outsideDepartment",
    path: "/supplySystem/:supplyId/userManagement/outsideDepartment",
    meta: { title: "外单位用户" },
    component: require("business/supplySystem/ensureUserManagement/outsideDepartment/list.vue").default
  }
];
